export default {"src":"/_next/static/media/UK.deaf4357.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};